import styled from 'styled-components'

export const MessageContainer = styled.div`
  margin-top: 16px;
`

export const PinForm = styled.div`
  padding: 16px 8px;
`
